<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-content-header
      title="Support Tiers"
      [saveButtonShown]="false"
      [sticky]="false"
      novaContentId="settings-support-tiers"></sbnb-content-header>

    <div
      *ngIf="!loading && prioritySupportInGracePeriod"
      class="pending-downgrade"
      fxLayoutAlign="start center"
      fxLayoutGap="12px">
      <span fxFlex>
        You are currently eligible for Priority Support until
        {{ user.priority_support.priority_support_ends_at | date: 'longDate' }}. After that, you will be downgraded.
      </span>
      <sbnb-button size="mini" type="secondary" (clicked)="keepPrioritySupportModal()">
        Keep Priority Support
      </sbnb-button>
    </div>

    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>

    <section *ngIf="!loading" fxLayout="column" fxLayoutGap="0px">
      <div
        class="award-winning-support-option"
        [class.readonly]="readOnly"
        [class.selected]="selectedTier === 'basic'"
        (click)="readOnly ? null : (selectedTier = 'basic')">
        <mat-radio-button
          [disabled]="readOnly"
          [checked]="selectedTier === 'basic'"
          value="basic"
          (change)="changedTier($event)">
          <span class="radio-label">Award-Winning Support (included)</span>
        </mat-radio-button>
        <ul>
          <li>
            Access to the
            <strong>highest rated support team in the industry</strong>
            (source G2).
          </li>
          <li>
            <strong>Live chat and email support</strong>
            with high quality answers from product experts, 24/5.
          </li>
          <li>
            Community Support with
            <a class="strong raspberry-darker" href="https://www.facebook.com/groups/hospitable/" target="_blank">
              our Facebook group
            </a>
            .
          </li>
          <li>Product and company insights in our legendary Townhalls every 2 weeks.</li>
        </ul>

        <div *ngIf="!user.priority_support.priority_support" class="g2-images">
          <img src="/assets/images/priority-support/g2_leader_winter_25.png" alt="G2 Leader Fall 23" />
          <img src="/assets/images/priority-support/g2_best_results_spring_24.png" alt="G2 Best Results Fall 23" />
          <img src="/assets/images/priority-support/g2_leader_winter_25.png" alt="G2 Best Relationship Fall 23" />
        </div>
      </div>

      <div
        [fxFlexOrder]="
          user.priority_support.priority_support || user.priority_support.priority_support_ends_at ? -1 : 2
        "
        class="priority-support-option"
        [class.readonly]="readOnly"
        [class.selected]="selectedTier === 'premium'"
        (click)="readOnly ? null : (selectedTier = 'premium')">
        <mat-radio-button
          [disabled]="readOnly"
          [checked]="selectedTier === 'premium'"
          value="premium"
          (change)="changedTier($event)">
          <span class="radio-label">
            Priority Support ({{ priorityPricing.base_amount }} minimum, {{ priorityPricing.per_property_amount }} per
            property after 3rd active property)
          </span>
        </mat-radio-button>
        <ul>
          <li>
            <strong>Jump the queue:</strong>
            all your conversations are marked as priority and answered first.
          </li>
          <li>
            <strong>Zoom Support:</strong>
            access to invitation-only 1:1 Zoom meetings with our product experts.
          </li>
          <li>
            <strong>WhatsApp Support:</strong>
            help even when you are on the go, and leave us a voice message.
          </li>
        </ul>

        <div *ngIf="user.priority_support.priority_support" class="g2-images">
          <img src="/assets/images/priority-support/g2_leader_winter_25.png" alt="G2 Leader Fall 23" />
          <img src="/assets/images/priority-support/g2_best_results_spring_24.png" alt="G2 Best Results Fall 23" />
          <img
            src="/assets/images/priority-support/g2_best_relationship_fall_24.png"
            alt="G2 Best Relationship Fall 23" />
        </div>
      </div>

      <div fxFlexOrder="3" class="vip-support-option">
        <mat-radio-button [disabled]="selectedTier !== 'vip' ? true : false" [checked]="selectedTier === 'vip'">
          <span class="radio-label">VIP Support (minimum $5,000 invested in Hospitable or 5 new users referred)</span>
        </mat-radio-button>

        <div class="vip-support-text">In addition to all features of Priority Support:</div>

        <ul>
          <li>
            <strong>Slack Support:</strong>
            access to our support, product & engineering teams on our #avengers channel.
          </li>
          <li>
            <strong>Investor Updates:</strong>
            monthly updates and quarterly meetups on the company growth and projects.
          </li>
          <li>
            <strong>CEO's WhatsApp:</strong>
            Connect with Pierre-Camille for insights, feedback, and priority assistance.
          </li>
        </ul>
      </div>

      <div fxFlexOrder="4" class="actions" *ngIf="!readOnly">
        <sbnb-button
          *ngIf="selectedTier === 'premium' && user.priority_support.priority_support === false"
          (clicked)="saveChanges()">
          Upgrade
        </sbnb-button>

        <sbnb-button
          *ngIf="selectedTier === 'basic' && user.priority_support.priority_support === true"
          type="secondary"
          (clicked)="saveChanges()">
          Downgrade
        </sbnb-button>
      </div>
    </section>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
